/**
 * beforeChange 处理函数类型
 */
export interface BeforeChangeFunction {
	(value?: any): boolean | void | Promise<any>
}

/**
 * beforeChange 处理工具函数
 * 直接调用形式：handleBeforeChange(beforeChange, value).then()
 *
 * @param beforeChange beforeChange 函数
 * @param value 要验证的值
 * @returns Promise
 */
export function handleBeforeChange<T = any>(
	beforeChange?: BeforeChangeFunction,
	value?: T
): Promise<T> {
	return new Promise((resolve, reject) => {
		try {
			if (!beforeChange) {
				resolve(value as T)
				return
			}

			const result = beforeChange(value)

			if (result && typeof (result as Promise<any>).then === 'function') {
				// 异步处理
				;(result as Promise<any>)
					.then(res => {
						if (res !== false) {
							resolve(value as T)
						} else {
							reject(new Error('beforeChange validation failed'))
						}
					})
					.catch(error => {
						reject(error)
					})
			} else {
				// 同步处理
				if (result !== false) {
					resolve(value as T)
				} else {
					reject(new Error('beforeChange validation failed'))
				}
			}
		} catch (error) {
			console.log(error)
		}
	})
}
